module.exports = __webpack_public_path__ + "static/img/mian-a.50a3e0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mian-a.png
// module id = iD4K
// module chunks = 1